export default __webpack_public_path__ + "static/media/logo_organisation.9fbf5f28.png";